// Web Tool Entries for ToolRegistry

import { forwardCallByName } from 'workers-common'

export function createWebTools({ getWorkerClient, workerName = 'myagent-worker' }) {
  const callWeb = async (ctx, method, args) => {
    const workerClient = getWorkerClient()
    return forwardCallByName(ctx, workerClient, workerName, `web.${method}`, [args])
  }

  return [
    {
      id: 'web/fetch',
      name: 'fetch',
      source: 'builtin',
      description: 'Fetch and extract content from a URL.',
      parameters: {
        type: 'object',
        properties: {
          url: { type: 'string', description: 'URL to fetch' },
          strategy: { type: 'string', description: 'Strategy: "raw", "smart", "jina", "puppeteer"' },
          maxLength: { type: 'number', description: 'Max content length (default: 10000)' },
          extractLinks: { type: 'boolean', description: 'Extract links (default: false)' },
          extractMetadata: { type: 'boolean', description: 'Extract metadata (default: true)' },
        },
        required: ['url'],
      },
      searchText: 'fetch\nFetch URL web page content extract scrape read website\n抓取网页 打开网址 获取内容 读取网页',
      examples: [
        { input: 'fetch the content of https://example.com', args: { url: 'https://example.com' } },
        { input: 'get the links from this page', args: { url: 'https://example.com', extractLinks: true } },
      ],
      execute: (ctx, args) => callWeb(ctx, 'fetch', args),
    },
    {
      id: 'web/webSearch',
      name: 'webSearch',
      source: 'builtin',
      description: 'Search the web. Supports DuckDuckGo, Google, Xiaohongshu, Zhihu.',
      parameters: {
        type: 'object',
        properties: {
          query: { type: 'string', description: 'Search query' },
          engine: { type: 'string', enum: ['duckduckgo', 'google', 'xiaohongshu', 'zhihu'], description: 'Search engine (default: duckduckgo)' },
          limit: { type: 'number', description: 'Max results (default: 10)' },
          fetchResults: { type: 'boolean', description: 'Fetch full content for top results (default: false)' },
        },
        required: ['query'],
      },
      searchText: 'webSearch\nSearch web internet google duckduckgo find online query\n搜索网页 在线搜索 谷歌搜索 百度搜索 查找信息',
      examples: [
        { input: 'search for latest news about AI', args: { query: 'latest AI news' } },
        { input: 'search xiaohongshu for travel tips', args: { query: 'travel tips', engine: 'xiaohongshu' } },
      ],
      execute: (ctx, args) => callWeb(ctx, 'search', args),
    },
  ]
}
